import React, { useState, useEffect } from 'react'
import { Form, Input, Modal, Button, App } from 'antd';
import { useKhlxrUpdateSaveMutation, useKhlxrDelMutation } from '../../store/DianShangYeWuApi';
function ClientContactEdit(props) {
    const { message, modal } = App.useApp();
    const [open, setOpen] = useState(false);
    const [info, setInfo] = useState({
        'khlxr_qy_id': props.qy_id,
        'khlxr_qy_name': props.qy_name,
        'khlxr_kh_id': props.kh_id,
        'khlxr_kh_name': props.kh_name,
        'khlxr_name': props.khlxr_name,
        'khlxr_phone': props.khlxr_phone,
        'khlxr_content': props.khlxr_content,
        'khlxr_uid': props.yh_id,
        'khlxr_uname': props.yh_name,
        'khlxr_id': props.khlxr_id,
        'khlxr_update_uname': props.yh_name
    });
    const [form] = Form.useForm();
    useEffect(() => {
        if(open){
            form.setFieldsValue({
                khlxr_name: props.khlxr_name,
                khlxr_phone: props.khlxr_phone,
                khlxr_content: props.khlxr_content,
            });
        }
    },[open, props, form]);
    const [updateSave] = useKhlxrUpdateSaveMutation();
    const [del] = useKhlxrDelMutation();
    return (
        <>
            <a onClick={() => {setOpen(true)}}>{props.khlxr_name}</a>
            <Modal
                open={open}
                width={800}
                onCancel={() => {setOpen(false)}} 
                title={props.kh_name}
                footer={[
                    <Button 
                        type='primary' 
                        key='save' 
                        onClick={() => {
                            updateSave(info).then(res => {
                                if(res.data.Status === 'success'){
                                    message.success('修改成功');
                                    setOpen(false);
                                    form.resetFields();
                                }else{
                                    message.error('修改失败'+res.data.Message);
                                }
                            });
                        }}
                    >保存</Button>,
                    <Button 
                        key='cancel' 
                        onClick={() => {
                            modal.confirm({
                                title: '确定删除该部门吗？',
                                content: '删除后不能恢复！',
                                okText: '确认',
                                okType: 'danger',
                                cancelText: '取消',
                                onOk: () => {
                                    del({khlxr_id: props.khlxr_id}).then(res => {
                                        if(res.data.Status === 'success'){
                                            message.success('删除成功');
                                            setOpen(false);
                                            form.resetFields();
                                        }else{
                                            message.error('删除失败'+res.data.Message);
                                        }
                                    });
                                }
                            }); 
                        }}
                    >删除</Button>,
                ]}
            >
                <Form 
                    form={form} 
                    name={`form_client_contact_edit_${props.khlxr_id}`} 
                    labelCol={{span: 4}} 
                    wrapperCol={{span: 20}}
                >
                    <Form.Item name='khlxr_name' label='部门名称' rules={[{ required: true, message: '请输入部门名称' }]}>
                        <Input onChange={(e) => {setInfo(prev => ({...prev, khlxr_name: e.target.value}))}} />
                    </Form.Item>
                    <Form.Item name='khlxr_phone' label='电话' >
                        <Input onChange={(e) => {setInfo(prev => ({...prev, khlxr_phone: e.target.value}))}} />
                    </Form.Item>
                    <Form.Item name='khlxr_content' label='备注' >
                        <Input onChange={(e) => {setInfo(prev => ({...prev, khlxr_content: e.target.value}))}} />
                    </Form.Item>
                    <Form.Item label='新增记录' >
                        {props.khlxr_ctime} {props.khlxr_uname}
                    </Form.Item>
                    <Form.Item label='修改记录' >
                        {props.khlxr_update_time} {props.khlxr_update_uname}
                    </Form.Item>
                </Form>
            </Modal>
        </>
    )
}

export default ClientContactEdit